import AppRouter from './routes/routes';
import { AuthProvider } from 'react-oidc-context';
import ConfigurationProvider from './shared/providers/ConfigurationProvider';
import { AxiosProvider } from './shared/providers/AxiosProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// https://tanstack.com/query/latest/docs/framework/react/guides/important-defaults
const queryClient = new QueryClient({
  // only revalidate data after a minute (less aggressive then assuming data is stale each time someone interacts with the page)
  defaultOptions: {
    queries: {
      staleTime: 60000,
      refetchOnWindowFocus: false, // Prevent refetch when switching tabs
    },
  },
});

if (!sessionStorage.getItem('destinationUrl')) {
  sessionStorage.setItem('destinationUrl', window.location.href.replace(window.location.origin, ''));
}

function App() {
  const config = window.FN_CONFIG;

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigurationProvider config={config}>
        <AuthProvider
          {...config.OIDC_CONFIGURATION}
          automaticSilentRenew={true}
          onSigninCallback={() => window.history.replaceState({}, document.title, window.location.pathname)}
        >
          <AxiosProvider>
            <AppRouter />
          </AxiosProvider>
        </AuthProvider>
      </ConfigurationProvider>
    </QueryClientProvider>
  );
}

export default App;
